import React, {useState, useEffect} from "react";
import {ANALYTICS_MONTHLY, PREMIUM_DATABASE_ACCESS} from "./constants";
import {useDispatch, useSelector} from "react-redux";
import LockIcon from "@mui/icons-material/Lock";
import KeyIcon from "@mui/icons-material/Key";
import {DUTCHIE, METRC} from "../../../constants";
import {isEmpty} from "weed-js";
import TestDutchieCredentials from "./TestCredentials/TestDutchieCredentials";
import {Button} from "@mui/material";
import {requestLinkback} from "../../../redux/user/Action";
import CreateMetrcAccount from "../../../components/forms/MetrcAccount";
import {selectIntegrationAccounts} from "../../../redux/models/integrations/Action";
import InfoIcon from "@mui/icons-material/Info";


export const MetrcTutorial = () => {
    return <div className={"create-account-metrc-tutorial"}>
        <h2>Getting your Metrc API Key</h2>
        <iframe width="560" height="315" src="https://www.youtube.com/embed/GrihZt0XD4M?si=olE_CxvfRf3l9I4u"
            title="YouTube video player" frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            referrerPolicy="strict-origin-when-cross-origin" allowFullScreen></iframe>
    </div>;
};


export const ShowHideInformation = ({title, children}) => {
    const [expanded, setExpanded] = useState(false);
    return <div className={"create-account-show-hide-information"}>
        <p className={"show=hide-information-title"} style={{color: "darkgray", cursor: "pointer"}} onClick={() => setExpanded(!expanded)}>{title}<InfoIcon/></p>
        <div className={"show-hide-information-content"}>
            {expanded ? children : null}
        </div>
    </div>

}

export const DutchieTutorial = ({formState}) => {
    const dispatch = useDispatch();
    return <div className={"create-account-dutchie-tutorial"}>
        <ShowHideInformation title={"Getting Your Dutchie API Key"}>
            <p>To get your API key for Dutchie, you&apos;ll have to send a request to their API team.</p>
            <p>Be sure to check your email for any follow-up questions from Dutchie. We will also send you an email so you can get back here without leaving this tab open.</p>
            <p>Once you have your API key, come back here and enter it in the fields below.</p>
            <Button onClick={() => {
                dispatch(requestLinkback(formState)).then(() => {
                    window.open("https://dutchie.webflow.io/request-api-key");
                });
            }}>Request Your API Key</Button>
        </ShowHideInformation>
    </div>
};


export const SetUpKeys = ({
    formState,
    setFormState,
    errors,
    setErrors,
    activeStep,
    setActiveStep,
    showPassword,
    setShowPassword,
    setCreatingAccount,
    allowBackNavigation,
    setAllowBackNavigation,
    integrationAccounts,
    setIntegrationAccounts,
    selectedIntegrationAccounts = [],
    formControls=null
}) => {

    const [tutorial, setTutorial] = useState(null);
    const metrcAccounts = useSelector(state => state.integrationReducer.accounts.metrc) || [];
    const dutchieAccounts = useSelector(state => state.integrationReducer.accounts.dutchie) || [];
    const dispatch = useDispatch();
    const selectedOrganization = useSelector(state => state.organizationReducer.selectedOrganization);

    useEffect(() => {
        if (allowBackNavigation) {
            return;
        }
        if (!isEmpty(integrationAccounts)) {
            setActiveStep(activeStep + 1);
        } else {
            setAllowBackNavigation(true);
        }
    });

    if (formState.integration === METRC) {
        const metrcAccount = metrcAccounts?.[0];
        return <div className={"create-account-choose-credential-state-container"}>
            <MetrcTutorial />
            <h2>Enter Your Credentials Here When You&apos;re Ready</h2>
            <CreateMetrcAccount
                id={metrcAccount?.id || null}
                display_name={metrcAccount?.display_name || ""}
                user_key={metrcAccount?.user_key || formState.api_key || ""}
                state_id={metrcAccount?.state_id || ""}
                organization_id={selectedOrganization?.id || ""}
                enableCreate={true}
                submitButtonText={"Save"}
                additionalControls={formControls}
                hideFrontendCredentials={true}
                onCreate={(newAccount) => {
                    setFormState({
                        ...formState,
                        api_key: newAccount.user_key,
                        confirm_api_key: newAccount.user_key,
                        location_name: newAccount.display_name,
                        state_id: newAccount.state_id,
                    });
                    setIntegrationAccounts([...integrationAccounts, newAccount]);
                    dispatch(selectIntegrationAccounts([
                        ...selectedIntegrationAccounts,
                        ...metrcAccounts,
                        newAccount
                    ]));
                }}
            />
        </div>;
    } else if (formState.integration === DUTCHIE) {
        return <div className={"create-account-choose-credential-state-container"}>
            <h2>Enter Your Credentials Here When You&apos;re Ready</h2>
            <DutchieTutorial formState={formState}/>
            <TestDutchieCredentials
                formState={formState}
                setFormState={setFormState}
                errors={errors}
                setErrors={setErrors}
                showPassword={showPassword}
                setShowPassword={setShowPassword}
                setCreatingAccount={setCreatingAccount}
                selectedIntegrationAccounts={selectedIntegrationAccounts}
            />
        </div>;
    }

    return <div className={"create-account-choose-credential-state-container"}>
        <div className={"create-account-choose-credential-state choose-analytics-monthly"}>
            <div className={"create-account-choose-credential-state-icon-container"}>
                <KeyIcon
                    className={"create-account-choose-credential-state-icon" + (formState.product === ANALYTICS_MONTHLY ? " selected" : "")}
                    onClick={() => {
                        console.log("Setting active step to ", activeStep + 1)
                        setActiveStep(activeStep + 1);
                    }}
                />
            </div>
            <h3>I have an API key</h3>
            <p>Great! Choose this option to enter your existing API key. Pro-tip: Make sure it has the permissions for the types of analytics you want to see.</p>
        </div>
        <div className={"create-account-choose-credential-state choose-premium"}>
            <div className={"create-account-choose-credential-state-icon-container"}>
                <LockIcon
                    className={"create-account-choose-credential-state-icon" + (formState.product === PREMIUM_DATABASE_ACCESS ? " selected" : "")}
                    onClick={() => setTutorial(formState.integration)}
                />
            </div>
            <h3>I need an API Key</h3>
            <p>No problem, we&apos;ll walk you through it.</p>
        </div>
    </div>
};


export default SetUpKeys;
